export default "__VITE_ASSET__4b93a2a5__"